<ng-container *ngIf="hasValidCoordinate">
  <h2>
    <strong translate>{{ title }}</strong>
  </h2>

  <div class="location-with-tools">
    <h2 (click)="this.localizer.requestLocalize(location.coordinate)">
      {{ location.FormattedLocation }}
    </h2>
    <div class="tools">
      <ion-button *ngFor="let tool of navigationTools.tools" (click)="tool.navigateTo(location)" fill="clear">
        <ion-icon [icon]="tool.icon" size="large" slot="icon-only"></ion-icon>
      </ion-button>
    </div>
  </div>
</ng-container>
